angular
    .module("app")
    .controller("questionarioAdvCtrl", function (
        $scope,
        $uniService,
        $modalService,
        $rootScope,
        $configService,
        $financialApiService,
        FileUploader,
        $download,
        $simulationService,
        $timeout
    ) {


        $rootScope.supportModel = {
            showQuestions: false,
            codiceIdentificativo: '',
            partitaIva: '',
            loader: false,
            email: '',
            confermaEmail: '',
            confirmButtonIsEnabled: false,
            buttonsModalEnabled: true,
            newAddedQuestAdv: {},
            submittedQuest: false,
            questionarioAdv: {},
            responseStarQuestionario: {}
        }

        $scope.loadingStatus = {
            uploading: false,
            suspend: false,
            submitArmamentiModal: false
        };



        $scope.handleChange = function (name, value) {
            $rootScope.supportModel[name] = value;
        }

        $scope.searchQuestion = function () {
            $rootScope.supportModel.loader = true;

            $uniService.getQuestAdvById($rootScope.supportModel.codiceIdentificativo, $rootScope.supportModel.partitaIva)
                .then(function (response) {
                    $rootScope.supportModel.questionarioAdv = response.questionario.metadataAdv
                    $rootScope.supportModel.responseStarQuestionario = response.questionario
                    $rootScope.supportModel.loader = false;
                    $rootScope.supportModel.showQuestions = true;
                })
                .catch(function (error) {
                    console.log(error);
                    $rootScope.supportModel.loader = false;
                })
        }

        $scope.exportModel = function (responseQuestionario, enableNextButton, newAdded) {
            $rootScope.supportModel.responseStarQuestionario = responseQuestionario
            $rootScope.supportModel.validityQuestionario = enableNextButton;
            $rootScope.supportModel.newAddedQuestAdv = newAdded;
        }

        $scope.handleChangeModal = function (name, value) {

            $rootScope.supportModel[name] = value
            if (name == 'email') {
                $rootScope.supportModel.responseStarQuestionario.metadataAdv.link.emailDest = value;
            }
            if ($rootScope.supportModel.responseStarQuestionario.metadataAdv.link.emailDest && $rootScope.supportModel.confermaEmail) {
                $rootScope.supportModel.emailPresent = true;
            } else {
                $rootScope.supportModel.emailPresent = false;
            }

            enableModalButton();
        }

        var enableModalButton = function () {
            if ((!!$rootScope.supportModel.confermaEmail && !!$rootScope.supportModel.responseStarQuestionario.metadataAdv.link.emailDest && $rootScope.supportModel.confermaEmail === $rootScope.supportModel.responseStarQuestionario.metadataAdv.link.emailDest) || !$rootScope.supportModel.responseStarQuestionario.metadataAdv.link.visibleEmail) {
                $rootScope.supportModel.confirmButtonIsEnabled = true;
            } else {
                $rootScope.supportModel.confirmButtonIsEnabled = false;
            }
        }

        $scope.submitQuestAdv = function (fromModal, fromModalArmamenti) {
            if($rootScope.supportModel.questionarioAdv.note.noteCommon.domandaArmamenti && !fromModalArmamenti && !$rootScope.supportModel.questionarioAdv.note.noteCommon.domandaArmamentiConferma) {
                $modalService.openModal("domandaArmamenti-modal");
                return;
            } else if($rootScope.supportModel.questionarioAdv.note.noteCommon.domandaArmamenti && fromModalArmamenti) {
                $rootScope.supportModel.questionarioAdv.note.noteCommon.domandaArmamentiConferma = true;
                $modalService.closeModal("domandaArmamenti-modal");
            }

            $rootScope.supportModel.buttonsModalEnabled = false;
            $scope.supportModel.loaderConfirm = true;
            if (fromModal) {
                $uniService.submitQuestADV($rootScope.supportModel.responseStarQuestionario)
                    .then(function (response) {
                        if (response.success) {
                            $rootScope.supportModel.submittedQuest = true;
                            $scope.closeModalMail('validateTit-modal');

                        }
                        $rootScope.supportModel.buttonsModalEnabled = true;
                        $scope.supportModel.loaderConfirm = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        $rootScope.supportModel.buttonsModalEnabled = true;
                        $scope.supportModel.loaderConfirm = false;
                    })

            } else {
                $scope.addNewValueIntoModelADV();
                Object.assign($rootScope.supportModel.responseStarQuestionario, {
                    email: $rootScope.supportModel.email
                })
                $uniService.validateRequestAdv($rootScope.supportModel.responseStarQuestionario)
                    .then(function (response) {
                        $scope.closeModalMail('modal-questAdv');
                        $rootScope.supportModel.buttonsModalEnabled = true;
                        if (response.details.showPopup) {
                            $scope.supportModel.loaderConfirm = false;
                            $scope.responseValidateRequest = response;
                            $modalService.openModal("validateTit-modal");
                        } else {
                            $uniService.submitQuestADV($rootScope.supportModel.responseStarQuestionario)
                                .then(function (response) {
                                    if (response.success) {
                                        $rootScope.supportModel.submittedQuest = true;

                                    }
                                    $rootScope.supportModel.buttonsModalEnabled = true;
                                    $scope.supportModel.loaderConfirm = false;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    $rootScope.supportModel.buttonsModalEnabled = true;
                                    $scope.supportModel.loaderConfirm = false;
                                })

                        }

                    })
                    .catch(function (error) {
                        console.log(error)
                        $rootScope.supportModel.buttonsModalEnabled = true;
                    })

            }

        }

        $scope.closeModalMail = function (id) {
            $modalService.closeModal(id)
        }

        $scope.closeArmamentiModal = function () {
            $modalService.closeModal("domandaArmamenti-modal");
        }

        $scope.confirmsQuestAdv = function () {
            $modalService.openModal('modal-questAdv');
            enableModalButton();
        }

        $scope.addNewValueIntoModelADV = function () {
            if ($rootScope.supportModel.newAddedQuestAdv.nuoviTitolari && $rootScope.supportModel.newAddedQuestAdv.nuoviTitolari.length) {

                $rootScope.supportModel.newAddedQuestAdv.nuoviTitolari.forEach(function (element) {
                    var checkCfIsPresent = $rootScope.supportModel.responseStarQuestionario.metadataAdv.titolari.titolari.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        $rootScope.supportModel.responseStarQuestionario.metadataAdv.titolari.titolari.push(element)
                    }
                })
            }

            if ($rootScope.supportModel.newAddedQuestAdv.nuoviEsecutori && $rootScope.supportModel.newAddedQuestAdv.nuoviEsecutori.length) {

                $rootScope.supportModel.newAddedQuestAdv.nuoviEsecutori.forEach(function (element) {
                    var checkCfIsPresent = $rootScope.supportModel.responseStarQuestionario.metadataAdv.esecutori.esecutori.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        $rootScope.supportModel.responseStarQuestionario.metadataAdv.esecutori.esecutori.push(element)
                    }
                })
            }

            if ($rootScope.supportModel.newAddedQuestAdv.nuoveFiduciarie && $rootScope.supportModel.newAddedQuestAdv.nuoveFiduciarie.length) {
                if (!$rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie) {
                    $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie = {
                        fiduciarie: []
                    }
                }
                $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie = $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.concat(newAddedQuestAdv.nuoveFiduciarie);

                $rootScope.supportModel.newAddedQuestAdv.nuoveFiduciarie.forEach(function (element) {
                    var checkCfIsPresent = $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.push(element)
                    }
                })
            }

            if ($rootScope.supportModel.newAddedQuestAdv.nuovoFiduciante && $rootScope.supportModel.newAddedQuestAdv.nuovoFiduciante.length) {
                if (!$rootScope.supportModel.responseStarQuestionario.metadataAdv.fiducianti) {
                    $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiducianti = {
                        fiducianti: []
                    }
                }
                $rootScope.supportModel.newAddedQuestAdv.nuovoFiduciante.forEach(function (element) {
                    var checkCfIsPresent = $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        $rootScope.supportModel.responseStarQuestionario.metadataAdv.fiducianti.fiducianti.push(element)
                    }
                })
            }

        }


        $scope.check = function (el) {
            el.isSelected = !el.isSelected;
        };

        // inizio procedura upload file
        $scope.uploader = new FileUploader({
            url: "",
            headers: {
                "Access-Control-Allow-Origin": "*",
                Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
                "App-Name": $rootScope.portalName,
            },
        });

        $scope.uploadDataFunc = function (item, index) {
            var document =
                arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            if (item) {
                $scope.uploadData = item;
            }
            $scope.uploadDocumenti = document;
        };

        $scope.finalUpload = function () {
            $scope.disabledForUploadingInProgress = true;
            for (var int = 0; int < $scope.uploader.queue.length; int++) {
                $scope.uploader.queue[int].url = $configService.getAppConfig().url +
                    "/uni/upload/service-infos/";
            }
            $scope.loadingStatus.uploading = true;
            var filesUpload = document.querySelector("#uploadInput_documentAdv").files;
            filesUpload = Object.keys(filesUpload).map(function (key) {
                return filesUpload[key];
            });
            var formData = new FormData();
            jQuery("#uploadInput_documentAdv").val("");
            filesUpload.forEach(function (file) {
                formData = new FormData();
                appendToForm(formData, "file", file);
                appendToForm(formData, "filename", file.name);
                appendToForm(formData, "idPratica", $rootScope.supportModel.responseStarQuestionario.id);
                $financialApiService
                    .uploadDocStatSocOnAdv(formData)
                    .then(function (response) {
                        if (response.success) {
                            $timeout(function () {
                                var tmp = {
                                    filename: file.name,
                                    id: response.id,
                                    cdDoc: $scope.uploadDocumenti.cdDocNsil,
                                    downloadKey: response.downloadKey
                                };

                                $scope.visualProgBarDoc = false;
                                $scope.responseValidateRequest.uploadDoc.uploadedFiles.push(tmp);
                            }, 1);
                        } else {
                            $scope.visualProgBarDoc = false;
                        }
                    })
                    .catch(function (error) {
                        $scope.visualProgBarDoc = false;
                    });

            });
        }

        $scope.generateDownloadLink = function (file) {
            var input = {};
            var url = "";
            if (file) {

                input = {
                    downloadKey: file.downloadKey
                }
                url = "/uni/downloadDocDigital/service-infos/"
            } else {
                input = {};
                url = "/uni/download/service-infos/GUIDA_UPLOAD_ADV/"
            }
            $download.getGenericDownload(url, input)
                .then(function (response) {
                    console.log(response)
                })

        };
        $scope.uploader.onWhenAddingFileFailed = function (item, filter, options) {
            console.info("onWhenAddingFileFailed", item, filter, options);
        };

        $scope.uploader.onAfterAddingFile = function (fileItem) {
            console.log("fileItem", fileItem);
            $scope.disabledForUploadingInProgress = true;
            $scope.progresso = 0;
            if (fileItem.file.size > 26214400) {
                $rootScope.$broadcast("addAlert", {
                    text: "MAXIMUM_FILE_SIZE_EXCEEDED",
                });
                fileItem.remove();
                jQuery("uploadInput_documentAdv" + $scope.currentCodeTypeNameIndex).val("");
            }
            var fileName = fileItem.file.name;
            //if ( ) {
            $scope.uploader.queue[0].progress = 100;

            $scope.visualProgBarDoc = true;

            $timeout(function () {
                $scope.progresso = 100;
            }, 500);
            /*     } else {
                  fileItem.remove();
                  jQuery("uploadInput_documentAdv" + $scope.currentCodeTypeNameIndex).val("");
                  $rootScope.$broadcast("addAlert", {
                    text: "FORMAT_NOT_SUPPORTED",
                  });
                  $scope.disabledForUploadingInProgress = false;
                  $scope.uploadInProgess({
                    uploadInProgess: false,
                  });
                } */
        };

        $scope.uploader.onAfterAddingAll = function (addedFileItems) {
            console.info("onAfterAddingAll", addedFileItems);
            $scope.finalUpload($scope.uploadData);
        };

        $scope.uploader.onBeforeUploadItem = function (item) {
            item.file.name = window.encodeURIComponent(item.file.name);
            item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
            $scope.disabledForUploadingInProgress = true;
            $scope.uploadInProgess({
                uploadInProgess: true,
            });
        };

        $scope.uploader.onProgressItem = function (fileItem, progress) {
            $scope.uploadCompleted = false;
        };

        $scope.uploader.onProgressAll = function (progress) { };

        $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
            $scope.loadingStatus.uploading = false;
        };

        $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
            console.info("onErrorItem", fileItem, response, status, headers);
            $scope.loadingStatus.uploading = false;
            jQuery("uploadInput_documentAdv" + $scope.currentCodeTypeNameIndex).val("");

            $rootScope.$broadcast("addAlert", {
                text: "ERROR_UPLOADING_FILE",
            });

            $scope.disabledForUploadingInProgress = false;
            $scope.uploadInProgess({
                uploadInProgess: false,
            });
            $timeout(function () {
                $scope.visualProgBarDoc = false;
            }, 1);

            fileItem.remove();
            jQuery("uploadInput_documentAdv" + $scope.currentCodeTypeNameIndex).val("");
        };

        $scope.uploader.onCancelItem = function (fileItem, response, status, headers) {
            console.log(status);
        };

        $scope.uploader.onCompleteItem = function (
            fileItem,
            response,
            status,
            headers
        ) {
            console.info("onCompleteItem", fileItem, response, status, headers);
            if (
                response &&
                response.uploadFileServicePojo &&
                response.uploadFileServicePojo.success
            ) {
                $scope.uploadOk = true;
                console.log(fileItem);

                var document = {
                    fileStatus: null,
                    isSelected: false,
                    nameFile: response.uploadFileServicePojo.fileName,
                    uuid: "",
                    errorMessage: "",
                    documentClass: "",
                };

                $scope.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
                    function (a, b) {
                        if (a.codiceDocNSIL > b.codiceDocNSIL) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }
                );
            }
            $scope.uploader.queue = [];

            $timeout(function () {
                $scope.visualProgBarDoc = false;

                $scope.disabledForUploadingInProgress = false;
                $scope.uploadInProgess({
                    uploadInProgess: false,
                });
            }, 1);
            jQuery("uploadInput_documentAdv" + $scope.currentCodeTypeNameIndex).val("");
        };

        $scope.uploader.onCompleteAll = function () {
            console.info("onCompleteAll");
            $scope.uploadCompleted = true;
        };

        $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
            $scope.uploading = false;
        };

        $scope.deletePrivacyDocument = function (index) {
            $scope.progresso = 100;

            $scope.visualProgBarDoc = true;

            $timeout(function () {
                $scope.progresso = 0;
            }, 200);

            $scope.documentsToBeDeleted = $scope.responseValidateRequest.uploadDoc.uploadedFiles
                .filter(function (elem) {
                    return elem.isSelected == true;
                });


            $scope.documentsToBeDeleted.forEach(function (element) {
                var checklistType = undefined;
                $simulationService
                    .deleteChecklistFileDigital(element.id, checklistType)
                    .then(function (response) {
                        console.log(response);
                        if (response.success) {
                            $timeout(function () {
                                $scope.visualProgBarDoc = false;
                                $scope.responseValidateRequest.uploadDoc.uploadedFiles = $scope.responseValidateRequest.uploadDoc.uploadedFiles
                                    .filter(function (e) {
                                        return e.isSelected != true;
                                    });

                            }, 1);
                        } else {
                            $scope.visualProgBarDoc = false;
                        }
                    })
                    .catch(function (error) {
                        $scope.visualProgBarDoc = false;
                    });
            });
        };

        $scope.genericTrashCheck = function () {
            return (
                $scope.responseValidateRequest.uploadDoc &&
                $scope.responseValidateRequest.uploadDoc.uploadedFiles &&
                $scope.responseValidateRequest.uploadDoc.uploadedFiles.some(function (element) {
                    return element.isSelected == true;
                })
            );
        }

        $scope.suspend = function (fromModal) {
            $scope.loadingStatus.suspend = true;
            if (!fromModal) {
                $modalService.openModal('suspendInstance');

            } else {
                $uniService.draftQuestAdv($rootScope.supportModel.responseStarQuestionario)
                    .then(response => {
                        if (response.success) {
                            $modalService.closeModal('suspendInstance');
                            $scope.supportModel.showQuestions = false;
                            $scope.supportModel.submittedQuest = false;
                            $scope.loadingStatus.suspend = false;
                            $scope.supportModel.codiceIdentificativo = null;
                            $scope.supportModel.partitaIva = null;

                        }
                    })
                    .catch(error => {
                        $modalService.closeModal('suspendInstance');
                        $scope.loadingStatus.suspend = false;
                    })
            }
        }

    });